import React from "react";
import { motion } from "framer-motion";

function colorFor(score) {
  if (score >= 71) return "#6366F1"; // indigo
  if (score >= 41) return "#F59E0B"; // amber
  return "#F97316"; // orange
}

export default function HealthGauge({ score = 0, size = 180, stroke = 14 }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score)) / 100;
  const color = colorFor(score);

  return (
    <div className="relative" style={{ width: size, height: size }} data-testid="health-gauge">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#E2E8F0" strokeWidth={stroke} />
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          initial={{ strokeDashoffset: c }}
          animate={{ strokeDashoffset: c - c * pct }}
          transition={{ duration: 1.1, ease: "easeOut" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="font-heading font-bold tracking-tight text-slate-900"
          style={{ fontSize: size * 0.28 }}
        >
          {score}
        </motion.span>
        <span className="text-xs text-slate-400 font-medium">out of 100</span>
      </div>
    </div>
  );
}
